import { c as _c } from "react/compiler-runtime";
import type { Money } from '@newfront-insurance/core-money';
import { CheckboxRow } from '@newfront-insurance/core-ui';
import { InputType } from '@newfront-insurance/dsl-schema-api';
import type { JSX } from 'react';
import { Label } from './label';
import { Value } from './value';
import type { SchemaFieldType } from '../../types';
interface Props {
  name: string;
  field: SchemaFieldType;
  // TODO: all the types "any" for values can be improved using generics depending on the InputType
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;
  accountUuid?: string;
}
export function DisplayItem(props) {
  const $ = _c(45);
  const {
    name,
    field,
    value,
    accountUuid
  } = props;
  const {
    inputType: type,
    inputMetadata: metadata
  } = field;
  const testId = `DisplayItem-${name}`;
  const label = metadata?.label || metadata?.subText || "";
  switch (type) {
    case "currencywithnumber":
      {
        const typedValue = value as {
          moneyLimit: Money;
          durationInMonthsLimit: number;
        } | undefined;
        const t0 = `${name}-currency`;
        let t1;
        if ($[0] !== label || $[1] !== t0) {
          t1 = <Label name={t0} label={label} />;
          $[0] = label;
          $[1] = t0;
          $[2] = t1;
        } else {
          t1 = $[2];
        }
        const t2 = `${name}-currency`;
        const t3 = field.properties?.moneyLimit;
        let t4;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
          t4 = {};
          $[3] = t4;
        } else {
          t4 = $[3];
        }
        let t5;
        if ($[4] !== metadata || $[5] !== t3) {
          t5 = {
            ...t3,
            inputMetadata: metadata,
            inputType: InputType.CURRENCY,
            errors: t4
          };
          $[4] = metadata;
          $[5] = t3;
          $[6] = t5;
        } else {
          t5 = $[6];
        }
        const t6 = typedValue?.moneyLimit;
        let t7;
        if ($[7] !== t2 || $[8] !== t5 || $[9] !== t6) {
          t7 = <Value name={t2} field={t5} value={t6} />;
          $[7] = t2;
          $[8] = t5;
          $[9] = t6;
          $[10] = t7;
        } else {
          t7 = $[10];
        }
        let t8;
        if ($[11] !== t1 || $[12] !== t7) {
          t8 = <div className="flex flex-col">{t1}{t7}</div>;
          $[11] = t1;
          $[12] = t7;
          $[13] = t8;
        } else {
          t8 = $[13];
        }
        const t9 = `${name}-number`;
        const t10 = metadata?.numberFieldLabel || "";
        let t11;
        if ($[14] !== t10 || $[15] !== t9) {
          t11 = <Label name={t9} label={t10} />;
          $[14] = t10;
          $[15] = t9;
          $[16] = t11;
        } else {
          t11 = $[16];
        }
        const t12 = `${name}-number`;
        let t13;
        if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
          t13 = {};
          $[17] = t13;
        } else {
          t13 = $[17];
        }
        let t14;
        if ($[18] !== metadata) {
          t14 = {
            inputMetadata: metadata,
            inputType: InputType.NUMBER,
            errors: t13
          };
          $[18] = metadata;
          $[19] = t14;
        } else {
          t14 = $[19];
        }
        const t15 = typedValue?.durationInMonthsLimit;
        let t16;
        if ($[20] !== t12 || $[21] !== t14 || $[22] !== t15) {
          t16 = <Value name={t12} field={t14} value={t15} />;
          $[20] = t12;
          $[21] = t14;
          $[22] = t15;
          $[23] = t16;
        } else {
          t16 = $[23];
        }
        let t17;
        if ($[24] !== t11 || $[25] !== t16) {
          t17 = <div className="flex flex-col">{t11}{t16}</div>;
          $[24] = t11;
          $[25] = t16;
          $[26] = t17;
        } else {
          t17 = $[26];
        }
        let t18;
        if ($[27] !== t17 || $[28] !== t8) {
          t18 = <div className="flex flex-row gap-4">{t8}{t17}</div>;
          $[27] = t17;
          $[28] = t8;
          $[29] = t18;
        } else {
          t18 = $[29];
        }
        return t18;
      }
    case "checkbox":
      {
        const t0 = metadata?.checkboxLabel || "";
        const t1 = !!value;
        let t2;
        if ($[30] !== t0 || $[31] !== t1 || $[32] !== testId) {
          t2 = <CheckboxRow testId={testId} label={t0} isActive={t1} disabled={true} />;
          $[30] = t0;
          $[31] = t1;
          $[32] = testId;
          $[33] = t2;
        } else {
          t2 = $[33];
        }
        return t2;
      }
    default:
      {}
  }
  let t0;
  if ($[34] !== label || $[35] !== name) {
    t0 = <Label name={name} label={label} />;
    $[34] = label;
    $[35] = name;
    $[36] = t0;
  } else {
    t0 = $[36];
  }
  let t1;
  if ($[37] !== accountUuid || $[38] !== field || $[39] !== name || $[40] !== value) {
    t1 = <Value name={name} field={field} value={value} accountUuid={accountUuid} />;
    $[37] = accountUuid;
    $[38] = field;
    $[39] = name;
    $[40] = value;
    $[41] = t1;
  } else {
    t1 = $[41];
  }
  let t2;
  if ($[42] !== t0 || $[43] !== t1) {
    t2 = <div className="flex w-full flex-col">{t0}{t1}</div>;
    $[42] = t0;
    $[43] = t1;
    $[44] = t2;
  } else {
    t2 = $[44];
  }
  return t2;
}